import { WEB_APP_PATHS } from '../../../utils/webAppPaths';

export const buildSourceSurfaceWebPath = ({
  surfaceId,
  applicationId,
}: {
  surfaceId: string;
  applicationId: string;
}): string => {
  const params = new URLSearchParams({ intent: 'graph', applicationId });

  return `${WEB_APP_PATHS.externalNetwork}/${encodeURIComponent(surfaceId)}?${params.toString()}`;
};
